import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './SafeIcon';

const {FiInstagram} = FiIcons;
const WA = 'https://wa.me/919876543210?text=Hi%20Aurelle!%20I%20saw%20a%20post%20I%20loved%20and%20want%20to%20enquire.';

const looks = [
  'https://images.unsplash.com/photo-1469334031218-e382a71b716b?auto=format&fit=crop&w=800&q=85',
  'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&w=800&q=85',
  'https://images.unsplash.com/photo-1445205170230-053b83016050?auto=format&fit=crop&w=800&q=85',
  'https://images.unsplash.com/photo-1496747611176-843222e1e57c?auto=format&fit=crop&w=800&q=85',
  'https://images.unsplash.com/photo-1551232864-3f0890e580d9?auto=format&fit=crop&w=800&q=85',
  'https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=800&q=85'
];

function InstagramSection() {
  return (
    <section id="journal" className="bg-[#EDE4D3] py-24 md:py-32 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <p className="eyebrow eyebrow-center mb-5" style={{color: '#1F3D2E'}}>Worn by you</p>
          <h2 className="font-display text-[clamp(36px,5vw,64px)] leading-tight text-[#1F1B17] font-light">
            Straight from <em className="italic text-[#1F3D2E]">our feed</em>
          </h2>
          <p className="mx-auto mt-5 max-w-md font-sans text-sm text-[#7A6E62] leading-relaxed">Tap any look to enquire about the pieces on WhatsApp.</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {looks.map((look,i) => (
            <motion.a key={look} href={WA} target="_blank" rel="noreferrer" initial={{opacity: 0,scale: 0.95}} whileInView={{opacity: 1,scale: 1}} viewport={{once: true,amount: 0.2}} transition={{delay: i * 0.06,duration: 0.45}} className="group relative block aspect-square overflow-hidden">
              <img src={look} alt="Aurelle look" className="w-full h-full object-cover transition duration-500 group-hover:scale-105" />
              <span className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-[#1F3D2E]/70 opacity-0 transition duration-300 group-hover:opacity-100">
                <SafeIcon icon={FiInstagram} className="text-2xl text-[#B87333]" />
                <span className="font-sans text-[9px] tracking-[0.25em] uppercase text-[#F7F2EA]">Enquire on WhatsApp</span>
              </span>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default InstagramSection;
